export default __webpack_public_path__ + "static/media/moredetaislbtn.48f70849.png";